import { RouteId } from './routes';
import { version } from '../package.json';
import { ValuesOf } from '@tmapy/beetlejuice-utils';

export type AppContext<T extends APP_TYPE = APP_TYPE> = {
  appType: T;
  homepage: RouteId;
};

export const VERSION = process.env.VITE_VERSION ?? version;

export const BASENAME = process.env.PUBLIC_URL;

/**
 * Used in url to identify similar pages under different apps
 */
export enum APP_TYPE {
  PREJIMKA = 'prejimka',
  MANAGER = 'manager',
  VYDEJ = 'vydej',
}

export enum QUERY_STATE {
  SUCCESS = 'SUCCESS',
  WAITING = 'WAITING',
  FAIL = 'FAIL',
  EMPTY = 'EMPTY',
}

// Tohle je zalezitost pouze Login stranky (nepatri do APP state)
export enum SUCCESS_ALERT_VISIBLE {
  SUBMIT = 'SUBMIT',
  DELETE = 'DELETE',
}

export const SET_CONFIG_TO_STORE = 'SET_CONFIG_TO_STORE';

export const appContextValues: Record<APP_TYPE, AppContext> = {
  [APP_TYPE.PREJIMKA]: {
    appType: APP_TYPE.PREJIMKA,
    homepage: 'prejimkaHome',
  },
  [APP_TYPE.MANAGER]: {
    appType: APP_TYPE.MANAGER,
    homepage: 'managerHome',
  },
  [APP_TYPE.VYDEJ]: {
    appType: APP_TYPE.VYDEJ,
    homepage: 'vydejHome',
  },
} as const;

export enum BACKEND_VALIDATION_CODE {
  NULL = 'null',
  EMPTY = 'empty',
  INVALID = 'invalid',
  UNIQUE = 'unique',
  UPPER_CASE_MISSING = 'upper_case_missing',
  INCORRECT_TYPE = 'incorrect_type',
  NO_ACTIVE_ACCOUNT = 'no_active_account',
  INVALID_CHOICE = 'invalid_choice',
  UNKNOWN_SERVER_ERROR = 'unknown_server_error',
}

export const LOG_LEVEL: Record<number, string> = {
  1: 'Fatal',
  2: 'Error',
  3: 'Warn',
  4: 'Info',
  5: 'Debug',
  6: 'Trace',
};

export const ORDER_IS_PUBLIC = { TRUE: 'TRUE', FALSE: 'FALSE' } as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ORDER_IS_PUBLIC = ValuesOf<typeof ORDER_IS_PUBLIC>;

export const ORDER_FROM_PRIMARY_DB = { TRUE: 'TRUE', FALSE: 'FALSE' } as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ORDER_FROM_PRIMARY_DB = ValuesOf<typeof ORDER_FROM_PRIMARY_DB>;
